import React, { useEffect } from "react";
import {
  makeStyles,
  useTheme,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import { connect } from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Link from "@material-ui/core/Link";
import { Button } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import watchlogo from "../../assests/images/watch-ops-logo.png";
import logo from "../../assests/images/logo.png";
import watchopsHeaderLogo from "../../assests/images/watchops-logo-header.png";
import icon from "../../assests/images/Group 1332.png";
import DashboardIcon from "../../assests/images/dashboard/Group 1919.svg";
import ProfileIcon from "../../assests/images/dashboard/Group 1912.svg";
import InventoryIcon from "../../assests/images/dashboard/Group 1899.svg";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { withRouter } from "react-router-dom";
import AdministrationIcon from "@mui/icons-material/SupervisorAccount";
import MyProfile from "@mui/icons-material/AccountCircleOutlined";
import BulkUpload from "@mui/icons-material/UploadFileOutlined";
import GridViewIcon from "@mui/icons-material/GridView";
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import { Link as RouterLink } from "react-router-dom";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import RequestPageOutlinedIcon from '@mui/icons-material/RequestPageOutlined';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
// import InventoryTransfer from "../../assests/images/Pivot.png";
import InventoryTransfer from "../../assests/images/recycle.png";
import Badge from "@mui/material/Badge";
import { getTransferPendingCount } from "../../components/pages/dashboard/actions/dashboardAction";
const themeImpresari = createMuiTheme({
  palette: {
    primary: {
      light: "#CAAB74",
      main: "#CEA05F",
      dark: "#CAAB74",
      contrastText: "#fff",
    },
    secondary: {
      light: "#CAAB74",
      main: "#383838",
      dark: "#CAAB74",
      contrastText: "#fff",
    },
  },
});
const useStyles = makeStyles((theme) => ({
  root: {},
  toolbar: {
    display: "flex",
    alignItems: "center",
    minHeight: "64px !important",
    position: "relative",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(3),
  },
  toolbarAuth: {
    minHeight: "64px !important",
    paddingLeft: "28px !important",
    paddingRight: "28px !important",
  },
  appBarAuth: {
    backgroundColor: "#1a1a1a !important",
    boxShadow: "none !important",
    borderBottom: "none",
  },
  logo: {
    marginTop: 0,
    marginRight: "10px",
    display: "block",
    verticalAlign: "middle",
  },
  menuButton: {
    marginRight: theme.spacing(2),
    marginLeft: "auto",
  },
  title: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },
  headerOptions: {
    display: "flex",
    flex: 1,
    justifyContent: "space-evenly",
    alignItems: "center",
    minHeight: "40px",
  },
  authBrand: {
    display: "inline-flex",
    alignItems: "center",
    textDecoration: "none !important",
    borderBottom: "none !important",
    boxShadow: "none",
    lineHeight: 0,
    "&:hover": {
      textDecoration: "none !important",
      borderBottom: "none !important",
    },
  },
  authBrandLogo: {
    display: "block",
    height: "36px",
    width: "auto",
    maxWidth: "200px",
    objectFit: "contain",
  },
  titleAuth: {
    borderBottom: "none !important",
    "& a": {
      textDecoration: "none !important",
      borderBottom: "none !important",
    },
  },
  /* Auth: Home / Contact Us / Login grouped on the right */
  headerAuthNav: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    gap: "36px",
  },
  headerAuthLoginLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
    color: "#CEA05F",
    fontSize: "14px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textDecoration: "none",
    lineHeight: 1,
    textTransform: "uppercase",
    "&:hover": {
      textDecoration: "none",
      color: "#d4b07a",
    },
  },
  headerAuthLoginIcon: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    background: "#ffffff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "& img": {
      width: "18px",
      height: "18px",
      objectFit: "contain",
      display: "block",
      filter: "none",
    },
  },
  headerNavLink: {
    display: "inline-flex",
    alignItems: "center",
    lineHeight: 1,
    letterSpacing: "0.04em",
    fontSize: "14px",
    fontWeight: 500,
    textDecoration: "none",
    color: "#ffffff",
    textTransform: "none",
    borderBottom: "2px solid transparent",
    "&:hover": {
      textDecoration: "none",
      color: "#CEA05F",
    },
  },
  headerNavLinkActive: {
    color: "#ffffff",
    borderBottomColor: "#CEA05F",
  },
  alighRight: {
    textAlign: "right",
  },
}));
let menuItemsdata = [
  {
    menuTitle: "SEARCH",
    pageURL: "/search",
    isPublic: false,
  },
  {
    menuTitle: "ADD INVENTORY",
    pageURL: "/create-inventory",
    isPublic: false,
  },
  {
    menuTitle: "MY INVENTORY",
    pageURL: "/myinventory",
    isPublic: false,
  },
  {
    menuTitle: "MY REQUESTS",
    pageURL: "/watch-request-list",
    isPublic: false,
  },
  {
    menuTitle: "DEALER INVENTORY",
    pageURL: "/dealerinventory",
    isPublic: false,
  },
  {
    menuTitle: "INVOICES",
    pageURL: "/invoices",
    isPublic: false,
  },
  // {
  //Comment on Jan 25
  //   menuTitle: "SUBSCRIPTION",
  //   pageURL: "/subscription",
  //   isPublic: true,
  // },
  {
    menuTitle: "LOGIN",
    pageURL: "/login",
    isPublic: true,
  },
];

const Header = (props) => {
  const activeStyle = { color: "red" };
  const { history, currentUser, logoutAction, location } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [Active, setActive] = React.useState(false);

  const currentPath = location?.pathname || "";
  const isAuthHeader =
    currentPath === "/" ||
    currentPath === "/login" ||
    currentPath === "/contactus" ||
    currentPath === "/sign-up" ||
    currentPath === "/register" ||
    currentPath === "/SignUp" ||
    currentPath === "/verify-email" ||
    currentPath === "/confirm-email" ||
    currentPath === "/forgot-password" ||
    currentPath === "/forgot-otp" ||
    currentPath === "/verify-otp" ||
    currentPath === "/reset-password" ||
    currentPath === "/set-password" ||
    currentPath === "/forgot-success" ||
    currentPath === "/email-verification" ||
    currentPath === "/mfa" ||
    currentPath === "/mfa-verification" ||
    currentPath === "/mfa-otp-verify" ||
    (currentPath.startsWith("/dealerfeed/") &&
      !sessionStorage.getItem("userDetails")) ||
    sessionStorage.getItem("temp_token")
  const headerUser = isAuthHeader ? null : currentUser;
  const activeAuthNav = (() => {
    if (currentPath === "/login") return "LOGIN";
    if (currentPath === "/contactus") return "CONTACT US";
    if (currentPath === "/" || currentPath === "/home") return "HOME";
    return null;
  })();

  const [menuItems, setmenuItems] = React.useState(menuItemsdata);
  const [activeMenuTitle, setActiveMenuTitle] = React.useState(
    () => localStorage.getItem("menuTitle") || null
  );
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [userData, setUserData] = React.useState(() => {
    try {
      return window.sessionStorage.getItem("userDetails")
        ? JSON.parse(window.sessionStorage.getItem("userDetails"))
        : null;
    } catch (error) {
      return null;
    }
  });
  const [transferPendingCount, setTransferPendingCount] = React.useState(() =>
    Number(
      userData?.transferPendingCount ??
        currentUser?.transferPendingCount ??
        userData?.transfer_pendingcount ??
        currentUser?.transfer_pendingcount ??
        0
    )
  );
  const [pendingCountLoaded, setPendingCountLoaded] = React.useState(false);
    const hasTransferPendingCount = transferPendingCount > 0;

    const canSeeMyRequests = [2, 3, 6].includes(userData?.roleId);
    const visibleMenuItems = menuItems.filter(
      (item) => item.menuTitle !== "MY REQUESTS" || canSeeMyRequests
  );

  const accountId =
    userData?.accountId ??
    currentUser?.accountId ??
    window.sessionStorage.getItem("accountId");

  React.useEffect(() => {
    if (!accountId || pendingCountLoaded) {
      return;
    }

    getTransferPendingCount(accountId, (error, response) => {
      setPendingCountLoaded(true);

      if (error || !response) {
        return;
      }

      const pendingCount = Number(
        response?.pending_count ??
          response?.transfer_pendingcount ??
          response?.transferPendingCount ??
          0
      );

      setTransferPendingCount(pendingCount);

      try {
        const storedUser = window.sessionStorage.getItem("userDetails");
        if (storedUser) {
          const parsedUser = JSON.parse(storedUser);
          const updatedUser = {
            ...parsedUser,
            transferPendingCount: pendingCount,
            transfer_pendingcount: pendingCount,
          };
          window.sessionStorage.setItem(
            "userDetails",
            JSON.stringify(updatedUser)
          );
          window.dispatchEvent(new Event("userDetailsUpdated"));
        }
      } catch (storageError) {
        console.error("Failed to sync pending count to session storage", storageError);
      }
    });
  }, [accountId, pendingCountLoaded]);

  const syncUserData = React.useCallback(() => {
    try {
      const storedUserData = window.sessionStorage.getItem("userDetails");
      setUserData(storedUserData ? JSON.parse(storedUserData) : null);
    } catch (error) {
      setUserData(null);
    }
  }, []);

  useEffect(() => {
    syncUserData();

    const handleUserDetailsUpdated = () => {
      syncUserData();
    };

    window.addEventListener("userDetailsUpdated", handleUserDetailsUpdated);
    window.addEventListener("storage", handleUserDetailsUpdated);

    return () => {
      window.removeEventListener("userDetailsUpdated", handleUserDetailsUpdated);
      window.removeEventListener("storage", handleUserDetailsUpdated);
    };
  }, [syncUserData]);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClick1 = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClose1 = () => {
    setAnchorEl(null);
  };
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClick = (menu) => {
    const userDetails = window.sessionStorage.getItem("userDetails")
      ? JSON.parse(window.sessionStorage.getItem("userDetails"))
      : null;
    // if(userDetails && !userDetails?.membertierid){
    //   return
    // }else{
    if (menu.menuTitle == "HOME") {
      window.location.href = "http://www.watchops.com/";
    } else {
      history.push(menu.pageURL);
    }
    setActive(menu.menuTitle);
    setActiveMenuTitle(menu.menuTitle);
    localStorage.setItem("menuTitle", menu.menuTitle);
  };

  const handleMobileMenuClick = (menu) => {
    // console.log("menu", menu);
    history.push(menu.pageURL);
    setActive(menu.menuTitle);
    setActiveMenuTitle(menu.menuTitle);
    localStorage.setItem("menuTitle", menu.menuTitle);
  };

  const handleButtonClick = (pageURL) => {
    history.push(pageURL);
  };

  const logout = () => {
    window.sessionStorage.removeItem("userDetails");
    window.sessionStorage.removeItem("sortByValue");
    window.sessionStorage.removeItem("dealerFilter");
    window.sessionStorage.removeItem("dealerFilterKey");
    window.sessionStorage.removeItem("dealerFilterDial");
    window.sessionStorage.removeItem("dealerName");
    window.sessionStorage.removeItem("selectedInvoiceDate");
    logoutAction(null);
    // history.push("https://watchops.com/");
    localStorage.removeItem("UserBusinessDetails");
    localStorage.removeItem("UserId");
    history.push("/login");
  };
  const jump_to = (link) => {
    history.push(link);
  };

  useEffect(() => {
    if (isAuthHeader) {
      setmenuItems([
        {
          menuTitle: "HOME",
          // pageURL: "www.watchops.com",
          pageURL: "www.wopstest.watchops.com",
          isPublic: true,
        },
        {
          menuTitle: "CONTACT US",
          pageURL: "/contactus",
          isPublic: true,
        },
        {
          menuTitle: "LOGIN",
          pageURL: "/login",
          isPublic: true,
        },
      ]);
      return;
    }
    //Comment on Jan 25
    // if (userData) {
    //   if(userData.membertierId === 11){
    //     const menuItemsdata = [
    //       {
    //         menuTitle: "SEARCH",
    //         pageURL: "/search",
    //         isPublic: false,
    //       },
    //       // {
    //       //   menuTitle: "SUBSCRIPTION",
    //       //   pageURL: "/dealersubscribtions",
    //       //   isPublic: true,
    //       // },
    //       {
    //         menuTitle: "LOGIN",
    //         pageURL: "/login",
    //         isPublic: true,
    //       },

    //     ];
    //     setmenuItems(menuItemsdata);

    //   }else if(userData.membertierId === 12){
    //     const menuItemsdata = [
    //       {
    //         menuTitle: "SEARCH",
    //         pageURL: "/search",
    //         isPublic: false,
    //       },
    //       {
    //         menuTitle: "ADD INVENTORY",
    //         pageURL: "/create-inventory",
    //         isPublic: false,
    //       },
    //       {
    //         menuTitle: "MY INVENTORY",
    //         pageURL:"/myinventory",
    //         isPublic: false,
    //       },
    //       // {
    //       //   menuTitle: "SUBSCRIPTION",
    //       //   pageURL: "/subscription",
    //       //   isPublic: true,
    //       // },
    //       {
    //         menuTitle: "LOGIN",
    //         pageURL: "/login",
    //         isPublic: true,
    //       },

    //     ];
    //     setmenuItems(menuItemsdata);

    //   }else if ((userData.membertierId === 13 || userData.membertierId === 14) ){

    //     if( (userData.roleId === 7 || userData.roleId === 8)){
    //       const menuItemsdata = [
    //         {
    //           menuTitle: "SEARCH",
    //           pageURL: "/search",
    //           isPublic: false,
    //         },
    //         {
    //           menuTitle: "ADD INVENTORY",
    //           pageURL: "/create-inventory",
    //           isPublic: false,
    //         },
    //         {
    //           menuTitle: "MY INVENTORY",
    //           pageURL:"/myinventory",
    //           isPublic: false,
    //         },
    //         {
    //           menuTitle: "INVOICES",
    //           pageURL: "/invoices",
    //           isPublic: false,
    //         },
    //         // {
    //         //   menuTitle: "SUBSCRIPTION",
    //         //   pageURL: "/subscribtion",
    //         //   isPublic: true,
    //         // },
    //         {
    //           menuTitle: "LOGIN",
    //           pageURL: "/login",
    //           isPublic: true,
    //         },

    //       ];
    //       setmenuItems(menuItemsdata);
    //     }

    //   }else{
    //     const menuItemsdata = [
    //       {
    //         menuTitle: "SEARCH",
    //         pageURL: "/search",
    //         isPublic: false,
    //       },
    //       {
    //         menuTitle: "ADD INVENTORY",
    //         pageURL: "/create-inventory",
    //         isPublic: false,
    //       },
    //       //temporarly added
    //       {
    //         menuTitle: "MY INVENTORY",
    //         pageURL:"/myinventory",
    //         isPublic: false,
    //       },
    //        //temporarly added
    //       {
    //         menuTitle: "INVOICES",
    //         pageURL: "/invoices",
    //         isPublic: false,
    //       },
    //       // {
    //       //   menuTitle: "SUBSCRIPTION",
    //       //   pageURL: "/subscription",
    //       //   isPublic: true,
    //       // },
    //       // {
    //       //   menuTitle: "MY DEALER INVENTORY",
    //       //   pageURL: `/privatedealerfeed`,
    //       //   isPublic: true,
    //       // },
    //       {
    //         menuTitle: "LOGIN",
    //         pageURL: "/login",
    //         isPublic: true,
    //       },

    //     ];
    //     setmenuItems(menuItemsdata);
    //   }

    // }
    if (userData) {
      if (userData && (userData.roleId === 7 || userData.roleId === 9)) {
        if (
          userData.dealerInventorySubscription === "no_subscription" ||
          userData.dealerInventorySubscription === null
        ) {
          let menuItemsdata = [
            {
              menuTitle: "SEARCH",
              pageURL: "/search",
              isPublic: false,
            },
            {
              menuTitle: "MY INVENTORY",
              pageURL: "/myinventory",
              isPublic: false,
            },
            {
              menuTitle: "INVOICES",
              pageURL: "/invoices",
              isPublic: false,
            },
            {
              menuTitle: "LOGIN",
              pageURL: "/login",
              isPublic: true,
            },
          ];
          setmenuItems(menuItemsdata);
        } else {
          let menuItemsdata = [
            {
              menuTitle: "SEARCH",
              pageURL: "/search",
              isPublic: false,
            },
            {
              menuTitle: "MY INVENTORY",
              pageURL: "/myinventory",
              isPublic: false,
            },
            {
              menuTitle: "DEALER INVENTORY",
              pageURL: "/dealerinventory",
              isPublic: false,
            },
            {
              menuTitle: "INVOICES",
              pageURL: "/invoices",
              isPublic: false,
            },
            {
              menuTitle: "LOGIN",
              pageURL: "/login",
              isPublic: true,
            },
          ];
          setmenuItems(menuItemsdata);
        }
      }
      if (userData && (userData.roleId === 8 || userData.roleId === 10)) {
        if (
          userData.dealerInventorySubscription === "no_subscription" ||
          userData.dealerInventorySubscription === null
        ) {
          let menuItemsdata = [
            {
              menuTitle: "SEARCH",
              pageURL: "/search",
              isPublic: false,
            },
            {
              menuTitle: "MY INVENTORY",
              pageURL: "/myinventory",
              isPublic: false,
            },
            {
              menuTitle: "INVOICES",
              pageURL: "/invoices",
              isPublic: false,
            },
            {
              menuTitle: "LOGIN",
              pageURL: "/login",
              isPublic: true,
            },
          ];
          setmenuItems(menuItemsdata);
        } else {
          let menuItemsdata = [
            {
              menuTitle: "SEARCH",
              pageURL: "/search",
              isPublic: false,
            },
            {
              menuTitle: "MY INVENTORY",
              pageURL: "/myinventory",
              isPublic: false,
            },
            {
              menuTitle: "DEALER INVENTORY",
              pageURL: "/dealerinventory",
              isPublic: false,
            },
            {
              menuTitle: "INVOICES",
              pageURL: "/invoices",
              isPublic: false,
            },
            {
              menuTitle: "LOGIN",
              pageURL: "/login",
              isPublic: true,
            },
          ];
          setmenuItems(menuItemsdata);
        }
      }
      if (
        userData.dealerInventorySubscription === "no_subscription" ||
        userData.dealerInventorySubscription === null
      ) {
        let menuItemsdata = [
          {
            menuTitle: "SEARCH",
            pageURL: "/search",
            isPublic: false,
          },
          {
            menuTitle: "ADD INVENTORY",
            pageURL: "/create-inventory",
            isPublic: false,
          },
          {
            menuTitle: "MY INVENTORY",
            pageURL: "/myinventory",
            isPublic: false,
          },
          {
            menuTitle: "INVOICES",
            pageURL: "/invoices",
            isPublic: false,
          },
          {
            menuTitle: "LOGIN",
            pageURL: "/login",
            isPublic: true,
          },
        ];
        setmenuItems(menuItemsdata);
      }
    } else if (!userData) {
      const filterItem = [
        {
          menuTitle: "HOME",
          pageURL: "www.watchops.com",
          isPublic: true,
        },
        // {
        // Comment on Jan 25
        //   menuTitle: "SUBSCRIPTION",
        //   pageURL: "/subscription",
        //   isPublic: true,
        // },
        {
          menuTitle: "CONTACT US",
          pageURL: "/contactus",
          isPublic: true,
        },
        {
          menuTitle: "LOGIN",
          pageURL: "/login",
          isPublic: true,
        },
      ];
      setmenuItems(filterItem);
    }
  }, [userData, isAuthHeader]);

  // Sync active menu title when route or menu items change
  React.useEffect(() => {
    try {
      if (isAuthHeader) {
        setActiveMenuTitle(activeAuthNav);
        if (activeAuthNav) {
          localStorage.setItem("menuTitle", activeAuthNav);
        } else {
          localStorage.removeItem("menuTitle");
        }
        return;
      }

      const routeMatches = (pageURL) => {
        if (!pageURL) return false;
        if (pageURL === "/") return currentPath === "/";
        if (pageURL === "/watch-request-list") {
          return (
            currentPath === "/watch-request-list" ||
            currentPath === "/watch-request" ||
            currentPath.startsWith("/watch-request-list/") ||
            currentPath.startsWith("/watch-request/")
          );
        }
        return (
          currentPath === pageURL ||
          currentPath.startsWith(pageURL + "/")
        );
      };

      const matched = menuItems.find((m) => {
        if (m.menuTitle === "MY REQUESTS") {
          return routeMatches("/watch-request-list");
        }
        return routeMatches(m.pageURL);
      });
      if (matched) {
        setActiveMenuTitle(matched.menuTitle);
        localStorage.setItem("menuTitle", matched.menuTitle);
      } else if (currentPath === "/") {
        setActiveMenuTitle("SEARCH");
        localStorage.setItem("menuTitle", "SEARCH");
      } else {
        const inventoryAliases = [
          "/inventory-detail",
          "/update-inventry-details",
          "/myinventory",
        ];
        const isInventoryRoute = inventoryAliases.some((p) =>
          currentPath.startsWith(p)
        );
        if (isInventoryRoute) {
          setActiveMenuTitle("MY INVENTORY");
          localStorage.setItem("menuTitle", "MY INVENTORY");
        } else {
          setActiveMenuTitle(null);
          localStorage.removeItem("menuTitle");
        }
      }
    } catch (e) {}
  }, [activeAuthNav, currentPath, isAuthHeader, menuItems]);

  const loginMenu = {
    menuTitle: "LOGIN",
    pageURL: "/login",
    isPublic: true,
  };
  return (
    <ThemeProvider theme={themeImpresari}>
      <div className={classes.root}>
        <AppBar
          position="static"
          color="secondary"
          className={isAuthHeader ? classes.appBarAuth : undefined}
          elevation={isAuthHeader ? 0 : 4}
        >
          <Toolbar
            className={`${classes.toolbar}${
              isAuthHeader ? ` ${classes.toolbarAuth}` : ""
            }`}
            disableGutters={isAuthHeader}
          >
            <Typography
              variant="h6"
              className={`${classes.title}${
                isAuthHeader ? ` ${classes.titleAuth}` : ""
              }`}
            >
              {isAuthHeader ? (
                <RouterLink to="/login" className={classes.authBrand} aria-label="WatchOps">
                  <img
                    className={classes.authBrandLogo}
                    src={watchopsHeaderLogo}
                    alt="WatchOps"
                  />
                </RouterLink>
              ) : (
                <RouterLink to="/search">
                  <img className={classes.logo} src={logo} alt="Logo" />
                </RouterLink>
              )}
            </Typography>

            {isMobile ? (
              <>
                <IconButton
                  edge="start"
                  className={classes.menuButton}
                  color="inherit"
                  aria-label="menu"
                  onClick={handleMenu}
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  open={open}
                  onClose={() => setAnchorEl(null)}
                  className="width-100"
                >
                  {visibleMenuItems.map((menuItem) => {
                    const { menuTitle, isPublic } = menuItem;
                    return (
                      <div
                        style={{
                          backgroundColor: "#383838",
                          borderBottom: "1px solid #545454",
                        }}
                        className="topnav"
                      >
                        <MenuItem style={{ fontWeight: "5px" }}>
                          {menuTitle === "LOGIN" ? (
                            <div>
                              {!headerUser ? (
                                <div>
                                  <Link
                                    size="large"
                                    href="javascript:void(0);"
                                    onClick={() => {
                                      jump_to("/login");
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <img src={icon} alt="user" width="20px" />
                                    &nbsp;&nbsp;LOGIN
                                  </Link>
                                </div>
                              ) : (
                                <div>
                                  <Link
                                    aria-controls="simple-menu"
                                    className={
                                      headerUser &&
                                        headerUser.firstName === menuTitle
                                        ? "color-CEA05F fontw-500"
                                        : "text-white"
                                    }
                                    aria-haspopup="true"
                                    // onClick={handleClick1}
                                    style={{ display: "flex", color: "" }}
                                  >
                                    <img
                                      src={
                                        (headerUser &&
                                          headerUser.profilePic) ||
                                        icon
                                      }
                                      alt="user"
                                      width="20px"
                                      style={{
                                        display: "inline-block",
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "50%",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "cover",
                                      }}
                                    />
                                    <span
                                      className="space-left-10"
                                      style={{ cursor: "pointer" }}
                                    >
                                      {headerUser != undefined
                                        ? headerUser.firstName +
                                        " " +
                                        headerUser.lastName
                                        : "LOGIN"}
                                    </span>
                                    <ArrowDropDownIcon />
                                  </Link>
                                  <MenuItem
                                    className="mobileMenu topnav"
                                    style={{
                                      borderBottom: "0.1px solid #524e4e",
                                      marginTop: "4px",
                                    }}
                                  >
                                    <Link
                                      className="text-white"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                      href="javascript:void(0);"
                                      onClick={() => {
                                        history.push({
                                          pathname: "/administration",
                                        });
                                      }}
                                    >
                                      <AdministrationIcon />
                                      &nbsp;Administration
                                    </Link>
                                  </MenuItem>

                                  <MenuItem
                                    className="mobileMenu topnav"
                                    style={{
                                      borderBottom: "0.1px solid #524e4e",
                                      marginTop: "4px",
                                    }}
                                  >
                                    <Link
                                      className="text-white"
                                      // href="/dashboard"
                                      href="javascript:void(0);"
                                      onClick={() => {
                                        // jump_to("dashboard");
                                        history.push({
                                          pathname: "/dashboard",
                                        });
                                      }}
                                    >
                                      <i
                                        class="fa fa-dashboard"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      &nbsp;Dashboard
                                    </Link>
                                  </MenuItem>

                                  <MenuItem
                                    className="mobileMenu topnav"
                                    style={{
                                      borderBottom: "0.1px solid #524e4e",
                                      marginTop: "4px",
                                    }}
                                  >
                                    <Link
                                      className="text-white"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                      // href="/dashboard"
                                      href="javascript:void(0);"
                                      onClick={() => {
                                        // jump_to("dashboard");
                                        localStorage.removeItem("menuTitle");
                                        history.push({
                                          pathname: "/myprofile",
                                        });
                                      }}
                                    >
                                      <MyProfile />
                                      &nbsp;My Profile
                                    </Link>
                                  </MenuItem>
                                  <MenuItem
                                    className="mobileMenu topnav"
                                    style={{
                                      borderBottom: "0.1px solid #524e4e",
                                      marginTop: "4px",
                                    }}
                                  >
                                    <Link
                                      className="text-white"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                      href="javascript:void(0);"
                                      onClick={() => {
                                        localStorage.removeItem("menuTitle");
                                        history.push({
                                          pathname: "/contactmanagement",
                                        });
                                      }}
                                    >
                                      <ContactPageOutlinedIcon />
                                      &nbsp;Contact Management
                                    </Link>
                                  </MenuItem>
                                  <MenuItem
                                    className="mobileMenu topnav"
                                    style={{
                                      borderBottom: "0.1px solid #524e4e",
                                      marginTop: "4px",
                                    }}
                                  >
                                    <Link
                                      className="text-white"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                      href="javascript:void(0);"
                                      onClick={() => {
                                        localStorage.removeItem("menuTitle");
                                        history.push({
                                          pathname: "/watch-request",
                                        });
                                      }}
                                    >
                                      <RequestPageOutlinedIcon />
                                      &nbsp;Request
                                    </Link>
                                  </MenuItem>
                                  {/* <MenuItem
                                    className="mobileMenu topnav"
                                    style={{
                                      borderBottom: "0.1px solid #524e4e",
                                      marginTop: "4px",
                                    }}
                                  >
                                    <Link
                                      className="text-white"
                                      style={{display:'flex',alignItems:'center'}}
                                      // href="/dashboard"
                                      href="javascript:void(0);"
                                      onClick={() => {
                                        // jump_to("dashboard");
                                        localStorage.removeItem("menuTitle")
                                        history.push({
                                              pathname: "/bulk-upload",
                                            });
                                      }}
                                    >
                                      <BulkUpload />{" "}
                                      &nbsp;Bulk Upload
                                    </Link>
                                  </MenuItem> */}

                                  <MenuItem className="mobileMenu topnav">
                                    <Link
                                      className="text-white"
                                      onClick={() => {
                                        localStorage.removeItem("menuTitle");
                                        logout();
                                      }}
                                      href="javascript:void(0);"
                                    >
                                      <i
                                        class="fa fa-sign-out"
                                        aria-hidden="true"
                                        style={{ paddingLeft: "4px" }}
                                      ></i>
                                      &nbsp; Sign Out
                                    </Link>
                                  </MenuItem>
                                </div>
                              )}
                            </div>
                          ) : (
                            <div>
                              <Link
                                color="inherit"
                                size="large"
                                href="javascript:void(0);"
                                  className={
                                  activeMenuTitle === menuTitle
                                    ? "color-CEA05F fontw-500"
                                    : "text-white"
                                }
                                onClick={() =>
                                  handleMenuClick(
                                    isPublic || headerUser
                                      ? menuItem
                                      : loginMenu
                                  )
                                }
                              >
                                {menuTitle}
                              </Link>
                            </div>
                          )}
                        </MenuItem>
                      </div>
                    );
                  })}
                </Menu>
              </>
            ) : isAuthHeader ? (
              <div className={classes.headerAuthNav}>
                {menuItems
                  .filter((item) => item.menuTitle !== "LOGIN")
                  .map((menuItem) => {
                    const { menuTitle } = menuItem;
                    const isActive = activeAuthNav === menuTitle;
                    const label =
                      menuTitle === "HOME"
                        ? "Home"
                        : menuTitle === "CONTACT US"
                        ? "Contact Us"
                        : menuTitle;
                    return (
                      <Link
                        key={menuTitle}
                        color="inherit"
                        href="javascript:void(0);"
                        className={`${classes.headerNavLink} ${
                          isActive ? classes.headerNavLinkActive : ""
                        }`}
                        onClick={() => handleMenuClick(menuItem)}
                      >
                        {label}
                      </Link>
                    );
                  })}
                <Link
                  size="large"
                  href="javascript:void(0);"
                  onClick={() => jump_to("/login")}
                  className={classes.headerAuthLoginLink}
                >
                  <span className={classes.headerAuthLoginIcon}>
                    <img src={icon} alt="" />
                  </span>
                  LOGIN
                </Link>
              </div>
            ) : (
              <div className={classes.headerOptions}>
                {visibleMenuItems.map((menuItem) => {
                  const { menuTitle, isPublic } = menuItem;
                  return (
                    <div key={menuTitle}>
                      {headerUser && [2, 3, 6].includes(userData?.roleId) && (
                        <IconButton
                          color="inherit"
                          onClick={() => history.push("/inventory-transfer")}
                          title="Inventory Transfer"
                          style={{ display: "none" }}
                        >
                          <img
                            src={InventoryTransfer}
                            alt="Inventory Transfer"
                            style={{
                              width: "36px",
                              height: "36px",
                              objectFit: "contain",
                            }}
                          />
                        </IconButton>
                      )}
                      {menuTitle === "LOGIN" ? (
                        <div>
                          {!headerUser ? (
                            <div>
                              <Link
                                size="large"
                                href="javascript:void(0);"
                                onClick={() => {
                                  jump_to("/login");
                                }}
                                style={{
                                  display: "flex",
                                  color: "",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={icon}
                                  alt="user"
                                  style={{
                                    display: "inline-block",
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "50%",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "cover",
                                  }}
                                />
                                &nbsp;&nbsp;LOGIN
                              </Link>
                            </div>
                          ) : (
                            <div>
                           <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            {headerUser && [2, 3, 6].includes(userData?.roleId) && (
                              <IconButton
                                color="inherit"
                                onClick={() => history.push("/inventory-transfer")}
                                title="Inventory Transfer"
                                style={{ padding: "1px", width: "32px", height: "32px", display: "none" }}
                              >
                                <Badge
                                  badgeContent={transferPendingCount}
                                  color="error"
                                  max={99}
                                  overlap="circular"
                                  anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                  }}
                                  >
                                 <img
                                  src={InventoryTransfer}
                                  alt="Inventory Transfer"
                                  style={{
                                    width: "36px",
                                    height: "36px",
                                    objectFit: "contain",
                                    filter: "brightness(0) invert(1)",
                                  }}
                                />
                                </Badge>
                              </IconButton>
                            )}
                              <Link
                                aria-controls="simple-menu"
                                className={
                                  headerUser &&
                                    headerUser.firstName === menuTitle
                                    ? "color-CEA05F fontw-500"
                                    : "text-white"
                                }
                                aria-haspopup="true"
                                onClick={handleClick}
                                style={{
                                  display: "flex",
                                  color: "",
                                  alignItems: "center",
                                  marginLeft: "50px",
                                }}
                              >
                                <img
                                  // src={currentUser?.profilePic || icon}
                                   src={(userData && userData.profilePic) || icon}
                                  alt="user"
                                  style={{
                                    display: "inline-block",
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "50%",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "cover",
                                  }}
                                />
                                <span
                                  className="space-left-10"
                                  style={{ cursor: "pointer" }}
                                >
                                  {headerUser && (headerUser.firstName || headerUser.lastName)
                                    ? headerUser.firstName +
                                    " " +
                                    headerUser.lastName
                                    : "LOGIN"}
                                </span>
                                <ArrowDropDownIcon />
                              </Link>
                           </div>

                              <Menu
                                className="menu1"
                                style={{ top: "35px", left: "10px" }}
                                id="customized-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                              >
                                <MenuItem>
                                  <Link
                                    className="color-383838"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    href="javascript:void(0);"
                                    onClick={() => {
                                      history.push({
                                        pathname: "/administration",
                                      });
                                    }}
                                  >
                                    <AdministrationIcon
                                      sx={{ width: "20px" }}
                                    ></AdministrationIcon>{" "}
                                    &nbsp;Administration
                                  </Link>
                                </MenuItem>

                                {/* <MenuItem>
                                  <Link
                                    className="color-383838"
                                    // href="/dashboard"
                                    href="javascript:void(0);"
                                    onClick={() => {
                                      // jump_to("dashboard");
                                      history.push({ pathname: "/dashboard" });
                                    }}
                                  >
                                    <img
                                      src={DashboardIcon}
                                      alt="DashboardIcon"
                                      width="20px"
                                    />{" "}
                                    &nbsp;Dashboard
                                  </Link>
                                </MenuItem> */}
                                <MenuItem>
                                  <Link
                                    className="color-383838"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    // href="/dashboard"
                                    href="javascript:void(0);"
                                    onClick={() => {
                                      // jump_to("dashboard");
                                      localStorage.removeItem("menuTitle");
                                      history.push({
                                        pathname: "/myprofile",
                                      });
                                    }}
                                  >
                                    <MyProfile />
                                    &nbsp;My Profile
                                  </Link>
                                </MenuItem>
                                {[2, 6, 3].includes(userData?.roleId) ? (
                                  <MenuItem>
                                    <Link
                                      className="color-383838"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                      // href="/dashboard"
                                      href="javascript:void(0);"
                                      onClick={() => {
                                        localStorage.removeItem("menuTitle");
                                        history.push({
                                          pathname: "/dashboard",
                                        });
                                      }}
                                    >
                                      <GridViewIcon />
                                      &nbsp;Dashboard
                                    </Link>
                                  </MenuItem>
                                ) : null}
                                <MenuItem>
                                  <Link
                                    className="color-383838"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    href="javascript:void(0);"
                                    onClick={() => {
                                      localStorage.removeItem("menuTitle");
                                      history.push({
                                        pathname: "/contactmanagement",
                                      });
                                    }}
                                  >
                                    <ContactPageOutlinedIcon />
                                    &nbsp;Contact Management
                                  </Link>
                                </MenuItem>
                                {userData?.accountdetails?.length ? (
                                  <>
                                    <hr />
                                    {userData?.accountdetails?.map(
                                      (account, index) => {
                                        return (
                                          <MenuItem
                                            onClick={() => {
                                              if (
                                                window.sessionStorage.getItem(
                                                  "accountId"
                                                ) !== account.accountid
                                              ) {
                                                window.sessionStorage.setItem(
                                                  "accountId",
                                                  account.accountid
                                                );
                                                window.location.reload();
                                              }
                                            }}
                                          >
                                            <Link
                                              className="color-383838"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                              href="javascript:void(0);"
                                            >
                                              {account.accountid ===
                                                window.sessionStorage.getItem(
                                                  "accountId"
                                                ) ? (
                                                <span
                                                  style={{
                                                    height: "10px",
                                                    width: "10px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "green",
                                                    marginLeft: "5px",
                                                  }}
                                                ></span>
                                              ) : (
                                                <span
                                                  style={{
                                                    height: "10px",
                                                    width: "10px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "#ccc",
                                                    marginLeft: "5px",
                                                  }}
                                                ></span>
                                              )}
                                              &nbsp;
                                              <span
                                                style={{
                                                  display: "block",
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  maxWidth: "180px",
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                {account.businessname}
                                              </span>
                                            </Link>
                                          </MenuItem>
                                        );
                                      }
                                    )}
                                    {/* <MenuItem>
                                      <Link
                                        className="color-383838"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                        href="javascript:void(0);"
                                        onClick={() => {
                                          localStorage.removeItem("menuTitle");
                                          history.push({
                                            pathname: "/inventory-transfer",
                                          });
                                        }}
                                      >
                                         <img
                                          src={InventoryTransfer}
                                          alt="Inventory Transfer"
                                          style={{
                                            width: "36px",
                                            height: "36px",
                                            objectFit: "contain",
                                          }}
                                        />
                                        &nbsp;Inventory Transfer
                                      </Link>
                                    </MenuItem> */}
                                    {/* {userData?.accountdetails?.length === 1 && 
                                 <MenuItem>
                                   <Link
                                     className="color-383838"
                                     style={{ display: 'flex', alignItems: 'center' }}
                                     href="javascript:void(0);"
                                    //  onClick={()=>setBusinessEnable(!businessEnable)}
                                   >
                                     <PersonAddIcon style={{ height: '20px' }} />
                                     &nbsp;Add another business
                                   </Link>
                                 </MenuItem>
                                } */}
                                  </>
                                ) : (
                                  ""
                                )}
                                <MenuItem>
                                  <Link
                                    className="color-383838"
                                    onClick={() => {
                                      localStorage.removeItem("menuTitle");
                                      logout();
                                    }}
                                    href="javascript:void(0);"
                                  >
                                    <i
                                      class="fa fa-sign-out"
                                      aria-hidden="true"
                                      style={{ paddingLeft: "4px" }}
                                    ></i>
                                    &nbsp; Sign Out
                                  </Link>
                                </MenuItem>
                              </Menu>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div>
                          <Link
                            color="inherit"
                            size="large"
                            href="javascript:void(0);"
                            className={
                              activeMenuTitle === menuTitle
                                ? "color-CEA05F fontw-500"
                                : "text-white"
                            }
                            onClick={() =>
                              handleMenuClick(
                                isPublic || headerUser ? menuItem : loginMenu
                              )
                            }
                          >
                            {menuTitle}
                          </Link>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </Toolbar>
        </AppBar>
        {/* <nav className={classes.alighRight} >
          <Button color="primary" onClick={() => handleButtonClick("/")}>HOME</Button>
          <Button color="inherit" onClick={() => handleButtonClick("/register")}>Register</Button>
          <Button color="inherit" onClick={() => handleButtonClick("/login")}>Login</Button>
          <Button color="inherit" onClick={() => handleButtonClick("/forgot-password")}>Forgot Password</Button>
          <Button color="inherit" onClick={() => handleButtonClick("/reset-password")}>Reset Password</Button>
      </nav> */}
      </div>
    </ThemeProvider>
  );
};
const mapStateToProps = (state) => {
  return { currentUser: state.auth.currentUser };
};
function mapDispatchToProps(dispatch) {
  return {
    logoutAction: (payload) => dispatch({ type: "LOGOUT", payload }),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
